// @core/api/endpoints/team/reset_team_user_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResetTeamUserSettingsRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Reset team user settings
 * Performs reset operation on team user settings.
 */
export async function ResetTeamUserSettings(
  team_id: string,
  data: ResetTeamUserSettingsRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/settings/user/reset`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
